export default __webpack_public_path__ + "static/media/ring.e6a9cc10.png";